import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "For better productivity, I watch 6 hours of TV a week",
  "description": "",
  "published": "2012-03-15T00:00:00.000Z",
  "redirect_from": ["/blog/for-better-productivity-i-watch-6-hours-of-tv-a-week/swizec/3988"],
  "categories": "Arts, Brain, Futurama, House, How I Met Your Mother, Sherlock Holmes, Stephen King, Television, Television program, Top Gear, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Television is a waste of time`}</em>{`, they say, `}<em parentName="p">{`nothing good can come of it and it's a horrible form of media consumption`}</em>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/tumblr_m05svnQFWA1qznd83o1_500.jpg",
        "alt": "Wandering locomotive",
        "title": "Wandering locomotive"
      }}></img></p>
    <p>{`With all the Big Brothers and Celebrity Top Models and Kim Kardashians out there ... who could blame them? Television really does seem like a colossal waste of time. Combine that with all the commercial breaks and forced broadcasting schedules and I wouldn't be surprised if everyone cancels their subscription.`}</p>
    <p>{`Hell, I'd cancel my `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Television",
        "title": "Television"
      }}>{`TV`}</a>{` subscription too, if it wasn't bundled with the internet.`}</p>
    <p>{`When I say I watch television, what I really mean is that I steal download the few shows I like watching every week and watch them under my own temporal rules. (`}<a parentName="p" {...{
        "href": "http://www.tv.com/shows/house/",
        "title": "House"
      }}>{`House MD`}</a>{`, `}<a parentName="p" {...{
        "href": "http://www.bbc.co.uk/topgear/",
        "title": "Top Gear (2002 TV series)"
      }}>{`Top Gear`}</a>{`, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/The_Walking_Dead_(TV_series)"
      }}>{`Walking Dead`}</a>{`, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Castle_tv"
      }}>{`Castle`}</a>{`, `}<a parentName="p" {...{
        "href": "http://www.tv.com/shows/how-i-met-your-mother/",
        "title": "How I Met Your Mother"
      }}>{`How I Met Your Mother`}</a>{`, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Futurama"
      }}>{`Futurama`}</a>{` ...)`}</p>
    <p><em parentName="p">{`But you're a busy guy, you freelance and blog and boxing practice and schoolwork and classes and you're on twitter and github and everywhere. How can you watch television!?`}</em></p>
    <p>{`I can do all that `}<em parentName="p">{`because`}</em>{` I watch television.`}</p>
    <p>{`Ever notice how your best ideas come on the crapper? Or in the shower? Or when taking a relaxed walk?`}</p>
    <p>{`Ever seen how `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/House_%28TV_series%29",
        "title": "House (TV series)"
      }}>{`House`}</a>{` solves all his cases? Or `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Sherlock_Holmes",
        "title": "Sherlock Holmes"
      }}>{`Sherlock Holmes`}</a>{`? Pretty much anyone in any fiction ever that solves anything difficult?`}</p>
    <p>{`Noticed how `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Albert_Einstein",
        "title": "Albert Einstein"
      }}>{`Einstein`}</a>{` was working as a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Patent_examiner",
        "title": "Patent examiner"
      }}>{`patent clerk`}</a>{` when coming up with `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/General_relativity",
        "title": "General relativity"
      }}>{`general relativity`}</a>{`? Or the fact that `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Stephen_King",
        "title": "Stephen King"
      }}>{`Stephen King`}</a>{` takes a walk every day (says so in a short stub biography attached to every recent-ish book, called "With a new preface by the author")`}</p>
    <h2 {...{
      "id": "brain-wandering"
    }}>{`Brain wandering`}</h2>
    <p>{`You must let your brain wander!`}</p>
    <p>{`Aimlessly, without purpose, without even expecting a result. You must take the time out of your busy day to just let your brain wander without focusing on anything in particular and I promise you, great things will happen.`}</p>
    <p>{`Creativity is born out of random connections between different ideas. But you can't have random ideas if you never leave your brain alone. If you keep focusing you'll never find the solution staring at you from behind the hill.`}</p>
    <p>{`This problem is so well known machine learning and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Artificial_intelligence",
        "title": "Artificial intelligence"
      }}>{`artificial intelligence`}</a>{` have developed a bunch of tactics to combat it - everything from simulated annealing to evolutionary approaches and often just simply adding a bunch of noise to the belief state.`}</p>
    <p>{`For me, the best brain wandering comes from watching television.`}</p>
    <p>{`Doing sports is great to relax your brain, but is also too involved for any deep thought. Reading books, great relaxation, but it pulls you in too much and you forget about everything else.`}</p>
    <p>{`TV, however, TV is just perfect. The stories are nice and predictable, no need to think, all the characters are always the same, most of your brain can be left to just passively take in images, while your imagination solves whatever problems have accumulated.`}</p>
    <p>{`It's a bit like dreaming really. A semi-vegetative state in which the brain has time to calmly digest.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mandythompson.com/2012/02/01/snapshot-01122012-an-honest-look-at-an-honest-moment/"
        }}>{`Snapshot 01122012 : An honest look at an honest moment.`}</a>{` (mandythompson.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.confused.com/news/household/home-insurance/tv-sets-getting-bigger-and-bigger-721795577"
        }}>{`TV sets getting bigger and bigger`}</a>{` (confused.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://changedbychange.com/2012/02/22/as-long-as-we-can-live-in-tvland-why-would-we-ever-want-to-live-in-ours/"
        }}>{`As Long As We Can Live in TVland, Why Would We Ever Want to Live in Ours?`}</a>{` (changedbychange.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://truthsupport.wordpress.com/2012/02/02/the-toddlers-brain-on-modern-television/"
        }}>{`The Toddler's Brain On Modern Television`}</a>{` (truthsupport.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.blippitt.com/this-is-your-childs-brain-on-television-infographic/"
        }}>{`This Is Your Child's Brain on Television (INFOGRAPHIC)`}</a>{` (blippitt.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://radiosilencer.wordpress.com/2012/03/08/five-reasons-to-cancel-your-cable-television/"
        }}>{`Five Reasons To Cancel Your Cable Television`}</a>{` (radiosilencer.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://pulsations.wordpress.com/2012/03/10/the-ideal-real-dichotomy-and-the-importance-of-observation/"
        }}>{`The ideal-real dichotomy and the importance of observation`}</a>{` (pulsations.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.blogher.com/snippets/tweeting-while-watching-where-twitter-meets-television"
        }}>{`Tweeting While Watching: Where Twitter Meets Television`}</a>{` (blogher.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=43846e03-6aaa-43fc-be21-9b43bc1b3db7",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      